var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-6 text-center"},[_c('v-btn',{on:{"click":_vm.windowClose}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-close")]),_vm._v("閉じる ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }